export default {
  title: 'Pokladna',
  subtitle: 'Zkontrolujte svou objednávku a potvrďte nákup.',
  emptyTitle: 'Není co zaplatit',
  emptyText: 'Váš košík je prázdný. Nejprve přidejte nějaké herní klíče.',
  browseCatalog: 'Procházet katalog',
  billingInformation: 'Fakturační údaje',
  edit: 'Upravit',
  name: 'Jméno',
  email: 'E-mail',
  country: 'Země',
  address: 'Adresa',
  city: 'Město',
  postalCode: 'PSČ',
  phone: 'Telefon',
  walletBalance: 'Zůstatek peněženky',
  topUp: 'Dobít',
  orderSummary: 'Souhrn objednávky',
  subtotal: 'Mezisoučet',
  discount: 'Sleva',
  total: 'Celkem',
  couponPlaceholder: 'Kód kupónu',
  couponApply: 'Použít',
  couponRemove: 'Odebrat',
  couponInvalid: 'Neplatný nebo vypršelý kód kupónu.',
  insufficientBalance: 'Nedostatečný zůstatek peněženky — dobijte si jej pro pokrytí této objednávky.',
  placeOrder: 'Odeslat objednávku',
  termsAgreementPre: 'Odesláním této objednávky souhlasíte s našimi',
  termsAndConditions: 'obchodními podmínkami',
  instantDelivery: 'Okamžité doručení klíče po zaplacení.',
  // Processing
  processing: 'Zpracování',
  processingPayment: 'Zpracování platby',
  processingPaymentPrefix: 'Zpracování',
  processingPaymentAccent: 'platby',
  processingText: 'Potvrzujeme vaši transakci u poskytovatele platby. Obvykle to trvá několik sekund.',
  reference: 'Reference: {ref}',
  doNotClose: 'Nezavírejte prosím toto okno ani neobnovujte stránku.',
  // Failed
  failed: 'Selhalo',
  payment: 'Platba',
  paymentFailed: 'selhala',
  failedText: 'Vaši transakci se nepodařilo dokončit. Z vaší peněženky nebyly strženy žádné prostředky.',
  reason: 'Důvod',
  orderId: 'Číslo objednávky',
  defaultReason: 'Nedostatečný zůstatek peněženky',
  contactSupportText: 'Pokud problém přetrvává, kontaktujte náš tým podpory.',
  tryAgain: 'Zkusit znovu',
  contactSupport: 'Kontaktovat podporu',
};
